import LegalInfoService from '../../services/LegalInfoService';
import legalInfoUseCase from './legalInfoUseCase';

const legalInfoFactory = legalInfoUseCase({
  LegalInfoService: LegalInfoService(),
});

export default legalInfoFactory;
